"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionDependenciesMap = exports.permissionDependentMap = exports.permissions = exports.EBTSPermissions = exports.TransactionsPermissions = exports.SettingsPermissions = exports.AuditPermissions = exports.LineupPermissions = exports.BookingPermissions = void 0;
var BookingPermissions;
(function (BookingPermissions) {
    BookingPermissions["BookingCreate"] = "booking:create";
    BookingPermissions["BookingView"] = "booking:view";
    BookingPermissions["BookingEdit"] = "booking:edit";
    BookingPermissions["BookingSubmit"] = "booking:submit";
    BookingPermissions["BookingCreateLineup"] = "booking:create-lineup";
    BookingPermissions["BookingSeal"] = "booking:seal";
    BookingPermissions["BookingUnseal"] = "booking:unseal";
    BookingPermissions["BookingPrint"] = "booking:print";
    BookingPermissions["BookingDeactivate"] = "booking:deactivate";
    BookingPermissions["BookingViewSealed"] = "booking:view-sealed";
    BookingPermissions["BookingHideSealed"] = "booking:hide-sealed";
    BookingPermissions["BookingDeleteImages"] = "booking:delete-images";
})(BookingPermissions = exports.BookingPermissions || (exports.BookingPermissions = {}));
var LineupPermissions;
(function (LineupPermissions) {
    LineupPermissions["LineupCreate"] = "lineup:create";
    LineupPermissions["LineupEdit"] = "lineup:edit";
    LineupPermissions["LineupView"] = "lineup:view";
    LineupPermissions["LineupPrint"] = "lineup:print";
    LineupPermissions["LineupDelete"] = "lineup:delete";
    LineupPermissions["LineupDuplicate"] = "lineup:duplicate";
})(LineupPermissions = exports.LineupPermissions || (exports.LineupPermissions = {}));
var AuditPermissions;
(function (AuditPermissions) {
    AuditPermissions["AuditView"] = "audit:view";
    AuditPermissions["AuditPrint"] = "audit:print";
    AuditPermissions["AuditExport"] = "audit:export";
})(AuditPermissions = exports.AuditPermissions || (exports.AuditPermissions = {}));
var SettingsPermissions;
(function (SettingsPermissions) {
    SettingsPermissions["SettingsUsersGroups"] = "settings:user-groups";
    SettingsPermissions["SettingsOIDC"] = "settings:oidc";
    SettingsPermissions["SettingsCreateUser"] = "settings:user-create";
    SettingsPermissions["SettingsEditUser"] = "settings:user-edit";
    SettingsPermissions["SettingsArchiveUser"] = "settings:user-archive";
    SettingsPermissions["SettingsUnarchiveUser"] = "settings:user-unarchive";
    SettingsPermissions["SettingsUserAuthAccess"] = "settings:user-auth-access";
    SettingsPermissions["SettingsCreateGroup"] = "settings:group-create";
    SettingsPermissions["SettingsEditGroup"] = "settings:group-edit";
    SettingsPermissions["SettingsDuplicateGroup"] = "settings:group-duplicate";
    SettingsPermissions["SettingsArchiveGroup"] = "settings:group-archive";
    SettingsPermissions["SettingsUnarchiveGroup"] = "settings:group-unarchive";
    // Applicable only when you want to assign a user to a group or remove it from an existing one.
    SettingsPermissions["SettingsAssignGroups"] = "settings:assign-groups";
})(SettingsPermissions = exports.SettingsPermissions || (exports.SettingsPermissions = {}));
var TransactionsPermissions;
(function (TransactionsPermissions) {
    TransactionsPermissions["TransactionsView"] = "transactions:view";
})(TransactionsPermissions = exports.TransactionsPermissions || (exports.TransactionsPermissions = {}));
var EBTSPermissions;
(function (EBTSPermissions) {
    EBTSPermissions["EBTSImport"] = "ebts:import";
})(EBTSPermissions = exports.EBTSPermissions || (exports.EBTSPermissions = {}));
var GenericLabels;
(function (GenericLabels) {
    GenericLabels["Create"] = "Create";
    GenericLabels["View"] = "View";
    GenericLabels["Edit"] = "Edit";
    GenericLabels["Seal"] = "Seal";
    GenericLabels["Unseal"] = "Unseal";
    GenericLabels["Archive"] = "Archive";
    GenericLabels["Print"] = "Print";
    GenericLabels["Export"] = "Export";
    GenericLabels["Duplicate"] = "Duplicate";
    GenericLabels["Deactivate"] = "Deactivate";
    GenericLabels["Import"] = "Import";
    GenericLabels["Delete"] = "Delete";
})(GenericLabels || (GenericLabels = {}));
exports.permissions = {
    Bookings: {
        [BookingPermissions.BookingCreate]: GenericLabels.Create,
        [BookingPermissions.BookingView]: GenericLabels.View,
        [BookingPermissions.BookingEdit]: GenericLabels.Edit,
        [BookingPermissions.BookingSubmit]: 'Submit',
        [BookingPermissions.BookingDeleteImages]: 'Delete booking images',
        [BookingPermissions.BookingCreateLineup]: 'Create lineup from booking',
        [BookingPermissions.BookingSeal]: GenericLabels.Seal,
        [BookingPermissions.BookingUnseal]: GenericLabels.Unseal,
        [BookingPermissions.BookingPrint]: GenericLabels.Print,
        [BookingPermissions.BookingDeactivate]: GenericLabels.Deactivate,
        [BookingPermissions.BookingViewSealed]: 'View sealed records',
        [BookingPermissions.BookingHideSealed]: 'Hide sealed records'
    },
    Lineups: {
        [LineupPermissions.LineupCreate]: GenericLabels.Create,
        [LineupPermissions.LineupView]: GenericLabels.View,
        [LineupPermissions.LineupPrint]: GenericLabels.Print,
        [LineupPermissions.LineupDuplicate]: GenericLabels.Duplicate,
        [LineupPermissions.LineupDelete]: GenericLabels.Delete
    },
    Audit: {
        [AuditPermissions.AuditView]: GenericLabels.View,
        [AuditPermissions.AuditPrint]: GenericLabels.Print,
        [AuditPermissions.AuditExport]: GenericLabels.Export
    },
    Settings: {
        [SettingsPermissions.SettingsOIDC]: 'OIDC',
        [SettingsPermissions.SettingsUsersGroups]: 'View users and groups page',
        [SettingsPermissions.SettingsCreateUser]: 'Add user',
        [SettingsPermissions.SettingsEditUser]: 'Edit user',
        [SettingsPermissions.SettingsArchiveUser]: 'Archive user',
        [SettingsPermissions.SettingsUnarchiveUser]: 'Unarchive user',
        [SettingsPermissions.SettingsUserAuthAccess]: "Change user's authentication access",
        [SettingsPermissions.SettingsCreateGroup]: 'Add group',
        [SettingsPermissions.SettingsEditGroup]: 'Edit group',
        [SettingsPermissions.SettingsDuplicateGroup]: 'Duplicate group',
        [SettingsPermissions.SettingsArchiveGroup]: 'Archive group',
        [SettingsPermissions.SettingsUnarchiveGroup]: 'Unarchive group',
        [SettingsPermissions.SettingsAssignGroups]: 'Assign groups to users'
    },
    Transactions: {
        [TransactionsPermissions.TransactionsView]: GenericLabels.View
    },
    EBTS: {
        [EBTSPermissions.EBTSImport]: GenericLabels.Import
    }
};
// Parent permissions with their dependents.
// If a permission is not included in the list it means it does not have any dependency.
const permissionsDependencies = {
    [BookingPermissions.BookingCreate]: [],
    [BookingPermissions.BookingView]: [],
    [BookingPermissions.BookingEdit]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingSubmit]: [BookingPermissions.BookingCreate, BookingPermissions.BookingEdit],
    [BookingPermissions.BookingCreateLineup]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingSeal]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingUnseal]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingPrint]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingDeactivate]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingViewSealed]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingHideSealed]: [BookingPermissions.BookingView],
    [BookingPermissions.BookingDeleteImages]: [BookingPermissions.BookingCreate, BookingPermissions.BookingEdit],
    [LineupPermissions.LineupView]: [],
    [LineupPermissions.LineupCreate]: [LineupPermissions.LineupView],
    [LineupPermissions.LineupDelete]: [LineupPermissions.LineupView],
    [LineupPermissions.LineupDuplicate]: [LineupPermissions.LineupView],
    [LineupPermissions.LineupEdit]: [LineupPermissions.LineupView],
    [LineupPermissions.LineupPrint]: [LineupPermissions.LineupView],
    [AuditPermissions.AuditView]: [],
    [AuditPermissions.AuditPrint]: [AuditPermissions.AuditView],
    [AuditPermissions.AuditExport]: [AuditPermissions.AuditView],
    [SettingsPermissions.SettingsUsersGroups]: [],
    [SettingsPermissions.SettingsCreateUser]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsEditUser]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsArchiveUser]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsUnarchiveUser]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsUserAuthAccess]: [
        SettingsPermissions.SettingsCreateUser,
        SettingsPermissions.SettingsEditUser
    ],
    [SettingsPermissions.SettingsCreateGroup]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsEditGroup]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsDuplicateGroup]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsArchiveGroup]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsUnarchiveGroup]: [SettingsPermissions.SettingsUsersGroups],
    [SettingsPermissions.SettingsAssignGroups]: [SettingsPermissions.SettingsUsersGroups],
    [TransactionsPermissions.TransactionsView]: [],
    [EBTSPermissions.EBTSImport]: []
};
const permissionsDependenciesTranspose = Object.entries(permissionsDependencies)
    .map(([child, parentsArr]) => {
    const mapped = parentsArr.map((parent) => ({ [parent]: child }));
    return Object.assign({}, ...mapped);
})
    .reduce((acc, items) => {
    Object.entries(items).forEach(([key, value]) => {
        acc[key] = [...(key in acc ? acc[key] : []), value];
    });
    return acc;
}, {});
// Map where key is dependent permission and value is an array of parent permissions
exports.permissionDependentMap = new Map(Object.entries(permissionsDependencies));
// Map where key is dependency(parent) permission and value is an array of child permissions
exports.permissionDependenciesMap = new Map(Object.entries(permissionsDependenciesTranspose));
//# sourceMappingURL=definitions.js.map